import { getBookingsRelativeUrl, queryBuilder, getUrlQueryParams, getSectionRelativeUrl, BOOKINGS_CALENDAR_SECTION_ID, isBookingsSectionInstalled, mapBasketToCalendarSelections, storeCalendarSelections, cleanCalendarSelections, ReservedSlug } from '@wix/bookings-catalog-calendar-viewer-utils';
async function getBookingCalendarRelativeUrl(wixCodeApi) {
  if (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) {
    return getSectionRelativeUrl(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID);
  }
  return getBookingsRelativeUrl(wixCodeApi);
}
async function navigateToBookingsCalendarPageWithBasket(wixCodeApi, platformAPI, basket, navigationContext) {
  var _basket$selectedServi, _basket$selectedServi2;
  if (navigationContext === void 0) {
    navigationContext = {};
  }
  const calendarSelections = mapBasketToCalendarSelections(basket);
  storeCalendarSelections({
    calendarSelections,
    session: platformAPI.storage.session
  });
  const slugName = basket == null || (_basket$selectedServi = basket.selectedServicesPreferences[0]) == null || (_basket$selectedServi = _basket$selectedServi.service) == null || (_basket$selectedServi = _basket$selectedServi.mainSlug) == null ? void 0 : _basket$selectedServi.name;
  const isSingleAppointment = slugName && (basket == null || (_basket$selectedServi2 = basket.selectedServicesPreferences) == null ? void 0 : _basket$selectedServi2.length) === 1;
  return navigateToBookingsBookAction(wixCodeApi, {
    serviceSlug: isSingleAppointment ? slugName : ReservedSlug.DATE_AND_TIME,
    referral: navigationContext.referral,
    timezone: navigationContext.timezone,
    bookingId: navigationContext.bookingId,
    skipPreferencesModal: navigationContext.skipPreferencesModal,
    copyCurrentQueryParams: false
  });
}
async function getUrlSuffix(wixCodeApi, serviceSlug) {
  return (await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CALENDAR_SECTION_ID)) ? `/${serviceSlug}` : `/${serviceSlug}/book`;
}
async function navigateToBookingsBookAction(wixCodeApi, _temp) {
  let {
    serviceSlug,
    referral,
    staff,
    location,
    timezone,
    selections,
    resource,
    bookingId,
    skipPreferencesModal,
    copyCurrentQueryParams
  } = _temp === void 0 ? {} : _temp;
  copyCurrentQueryParams = copyCurrentQueryParams ?? true;
  const suffix = serviceSlug ? await getUrlSuffix(wixCodeApi, serviceSlug) : '';
  const query = queryBuilder({
    ...(copyCurrentQueryParams ? getUrlQueryParams(wixCodeApi) : {}),
    ...(serviceSlug ? {
      staff,
      timezone,
      location
    } : {
      selections
    }),
    referral,
    resource,
    bookingId,
    skipPreferencesModal
  });
  const bookingCalendarRelativeUrl = await getBookingCalendarRelativeUrl(wixCodeApi);
  wixCodeApi.location.to(`${bookingCalendarRelativeUrl}${suffix + query}`);
}
export async function navigateToCalendarPage(wixCodeApi, platformAPI, _ref) {
  let {
    serviceSlugOrBasket,
    navigationContext = {}
  } = _ref;
  cleanCalendarSelections({
    session: platformAPI.storage.session
  });
  if (typeof serviceSlugOrBasket === 'string' || serviceSlugOrBasket instanceof String) {
    return navigateToBookingsBookAction(wixCodeApi, {
      ...navigationContext,
      serviceSlug: serviceSlugOrBasket
    });
  } else {
    return navigateToBookingsCalendarPageWithBasket(wixCodeApi, platformAPI, serviceSlugOrBasket, navigationContext);
  }
}
//# sourceMappingURL=navigateToBookingsCalendarPage.js.map